import { useMutation, useQueryClient } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

export function useMutationAiDraftUse(roomId: string) {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: ({
			draftId,
			finalText,
		}: {
			draftId: string
			finalText?: string
		}) => chatService.markAiDraftUsed(draftId, finalText),
		onSuccess: () => {
			queryClient.setQueryData(chatKeys.aiDraft(roomId), null)
		},
	})
}

export function useMutationAiDraftEdit(roomId: string) {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: ({
			draftId,
			finalText,
		}: {
			draftId: string
			finalText: string
		}) => chatService.markAiDraftEdited(draftId, finalText),
		onSuccess: () => {
			queryClient.setQueryData(chatKeys.aiDraft(roomId), null)
		},
	})
}

export function useMutationAiDraftIgnore(roomId: string) {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (draftId: string) => chatService.markAiDraftIgnored(draftId),
		onSuccess: () => {
			queryClient.setQueryData(chatKeys.aiDraft(roomId), null)
		},
	})
}
